import React from 'react'
import Dashnav from '../Components/Dashnav'
import Leftmenu from '../Components/Leftmenu'
import ChatComp from './ChatComp'

function Chat() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <ChatComp/>
     
            </div>
        </div>  
    </div>
  )
}

export default Chat